import React, { type ComponentType } from 'react';

import { useConnectionsList } from '../../controllers/connections-list/index.tsx';
import type { ConnectionsSubscriberProps } from '../../common/types.tsx';
import { useUpdateConnectionDetails } from '../../controllers/issue-realtime-updater/utils.tsx';

type ConnectionsSubscriberContainerProps = {
	ConnectionsSubscriber: ComponentType<ConnectionsSubscriberProps>;
};

export const ConnectionsSubscriberContainer = ({
	ConnectionsSubscriber,
}: ConnectionsSubscriberContainerProps) => {
	const { connections } = useConnectionsList();

	const updateConnectionDetails = useUpdateConnectionDetails();
	return (
		<ConnectionsSubscriber
			connections={connections}
			updateConnectionDetails={updateConnectionDetails}
		/>
	);
};
